const buySteps = {
  step_1: 0,
  step_2: 1,
  sureSteps: {
    step_1: 2,
    step_2: 3,
    step_3: 4,
    buy: {
      step_1: 5,
      step_2: 6,
      step_3: 7,
      step_4: 8,
      step_5: 9,
    },
    swap: {
      step_1: 10,
      step_2: 11,
      step_3: 12,
      step_4: 13,
      step_5: 14,
      step_6: 15,
      step_7: 16,
    },
  },
  wishesSteps: {
    step_1: 17,
    step_2: 18,
    step_3: 19,
    step_4: 20,
    step_5: 21,
    step_6: 22,
    step_7: 23,
    step_8: 24,
    step_9: 25,
    buy: {
      step_1: 26,
      step_2: 27,
      step_3: 28,
      step_4: 29,
      step_5: 30,
    },
    swap: {
      step_1: 31,
      step_2: 32,
      step_3: 33,
      step_4: 34,
      step_5: 35,
      step_6: 36,
      step_7: 37,
    },
  },
  selectionSteps: {
    step_1: 38,
    step_2: 39,
    step_3: 40,
    swap: {
      step_1: 41,
      step_2: 42,
      step_3: 43,
      step_4: 44,
      step_5: 45,
      step_6: 46,
      step_7: 47,
      step_8: 48,
      step_9: 49,
      step_10: 50,
      step_11: 51,
      step_12: 52,
      step_13: 53,
      step_14: 54,
      step_15: 55,
      step_16: 56,
    },
    buy: {
      step_1: 57,
      step_2: 58,
      step_3: 59,
      step_4: 60,
      step_5: 61,
      step_6: 62,
      step_7: 63,
      step_8: 64,
      step_9: 65,
      step_10: 66,
      step_11: 67,
      step_12: 68,
      step_13: 69,
      step_14: 70,
    },
  },
};

export default buySteps;
